import React from 'react';

import Header from '../components/header/Header';
import Login from '../components/login/Login';
// import Footer from '../components/footer/Footer';

const login = () => {
    return (
        <div>
            <Header />
            <Login />
        </div>
    );
};

export default login;


// WEBPACK FOOTER //
// ./src/pages/login.js